import { TextMap } from '../types'

const zh: TextMap = {
  choose_preferred_wallet: '选择你的钱包',
  connect_mobile_wallet: '连接至移动端钱包',
  scan_qrcode_with_wallet: '使用Gotabit钱包扫描二维码',
  connect: '连接',
  qrcode: '二维码',
  mobile: '移动',
  desktop: '桌面',
  copy_to_clipboard: '复制到剪贴板',
  copied_to_clipboard: '复制到剪贴板成功！',
  connect_with: '通过以下方式连接',
  loading: '正在加载...',
  something_went_wrong: '出了问题',
  no_supported_wallets: '目前还没有支持的钱包',
  no_wallets_found: '没有找到钱包',
}

export default zh
